// extracted by mini-css-extract-plugin
export var modal = "_ta-0";
export var table = "_ta-1";